export default function eventsFormPrint(payload) {
  return function(dispatch) {
    let form = document.createElement('form');
    form.target = '_blank';
    form.method = 'post';
    form.action = REST_URL+'trackEvents/printBlank';
    form.style = 'display:none;';

    let trackIdInput = document.createElement('input');
    trackIdInput.name = 'trackId';
    trackIdInput.value = payload.trackId;
    form.appendChild(trackIdInput);

    payload.sections.forEach((item) => {
      let sectionsInput = document.createElement('input');
      sectionsInput.name = 'sections[]';
      sectionsInput.value = item;
      form.appendChild(sectionsInput);
    });

    let grayscaleInput = document.createElement('input');
    grayscaleInput.name = 'colored';
    grayscaleInput.value = !payload.grayscale;
    form.appendChild(grayscaleInput);

    document.body.appendChild(form);
    form.submit();
    form.remove();

    dispatch({
      type: 'EVENTS_FORM_PRINT',
      payload: payload
    });
  }
};
